import { RootState } from '@redux/store';

export const getUserProfileData = (state: RootState) => state.user.userProfileData;
export const getIsLoadedUserProfileData = (state: RootState) => state.user.isLoadedUserProfileData;
